export default __webpack_public_path__ + "static/media/failed-to-fetch.6d39dce6.gif";